const initialState = {
  rss: 0,
  heapUsed: 0,
  heapTotal: 0,
  external: 0,
  timestamp: null
};

export const SET_MEMORY_USAGE = "SET_MEMORY_USAGE";

export function setMemoryUsage(memoryData) {
  return { type: SET_MEMORY_USAGE, payload: memoryData };
}

export default function memoryUsageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MEMORY_USAGE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
